import { render, staticRenderFns } from "./ChannelSearch.vue?vue&type=template&id=1bca0cba&"
import script from "./ChannelSearch.vue?vue&type=script&lang=ts&"
export * from "./ChannelSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports